const curren_env_index = process.env.VUE_APP_INTER
const curren_env_items = process.env.VUE_APP_Theme
let apiurl, apiws
if (curren_env_items == 'rrty-theme') {
  if (curren_env_index == 1) {
    apiurl = "https://kb-api.vx8wszdmqerg0xs6.cc/";
    apiws = "wss://ws.t4z5p5s9k4q3m4h4m3.org/ws";
  } else if (curren_env_index == 2) {
    apiurl = "https://starter-api.88zb3355.com/";
    apiws = "wss://public.88zb3355.com/ws";
  } else if (curren_env_index == 3) {
    apiurl = "http://pstarter-api.88zb3355.com/";
    apiws = "ws://pre-go-ws.88zb3355.com:8080/ws";
  }
} else if (curren_env_items == 'fszb-theme') {
  if (curren_env_index == 1) {
    apiurl = "https://api.v8d2r5e4m6s5j4e1.vip/";
    apiws = "wss://ws.n8u4z2s4j8m6d9g7.xyz/ws";
  } else if (curren_env_index == 2) {
    apiurl = "http://starter-api.88zb3355.com/";
    apiws = "wss://public.88zb3355.com/ws";
  } else if (curren_env_index == 3) {
    apiurl = "http://pstarter-api.88zb3355.com/";
    apiws = "ws://pre-go-ws.88zb3355.com:8080/ws";
  }
} else if (curren_env_items == 'okzb-theme') {
  if (curren_env_index == 1) {
    apiurl = "https://api.s1kz15bkuwmj.com/";
    apiws = "wss://ws.uwlfqe6nlkebv.com/ws";
  } else if (curren_env_index == 2) {
    apiurl = "https://kb-api.oktest.cc";
    apiws = "wss://go-ws.oktest.cc/ws";
  } else if (curren_env_index == 3) {
    apiurl = "http://pstarter-api.88zb3355.com/";
    apiws = "ws://pre-go-ws.88zb3355.com:8080/ws";
  }
} else if (curren_env_items == 'vnzb-theme') {
  if (curren_env_index == 1) {
    apiurl = "https://api.kw6gwtxhzouwzu.com/";
    apiws = "wss://ws.dpd9bhuzi8j0nx.com/ws";
  } else if (curren_env_index == 2) {
    apiurl = "https://starter-api.88zb3355.com/";
    apiws = "wss://public.88zb3355.com/ws";
  } else if (curren_env_index == 3) {
    apiurl = "http://pstarter-api.88zb3355.com/";
    apiws = "ws://pre-go-ws.88zb3355.com:8080/ws";
  }
}

const requestOperate = {
  themeApi: apiurl,
  themeWs: apiws,
}
module.exports = requestOperate